// The signed-in user managing their own identity record. `Users` is the identity server's own route
// (used by the accounts app, whose API is the identity server); `Profile` is the Sales API route that
// mirrors it. Both expose the same sub-routes, so the same actions and dialogs serve either app.
export type AgTechUserProfileRoute = 'Users' | 'Profile'

export type AgTechUserProfileAddress = {
    lineOne: string,
    lineTwo: string,
    city: string,
    zip: string,
    stateProvinceId: number
}

export type AgTechUserProfile = {
    firstName: string,
    lastName: string,
    userName: string,
    email: string,
    phoneNumber: string,
    address?: AgTechUserProfileAddress
}

export const DefaultAgTechUserProfileAddress: AgTechUserProfileAddress = {
    lineOne: '',
    lineTwo: '',
    city: '',
    zip: '',
    stateProvinceId: 0
}

export type AgTechUpdateUserProfileDTO = {
    firstName: string,
    lastName: string,
    phoneNumber: string
}
